import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("iframe", {
    style: { "display": "none" },
    onload: "resizeTextarea(1,7),resizeTextarea(2,7),resizeTextarea(3,7),resizeTextarea(4,7),resizeTextarea(5,7)"
}, null, -1);
const _hoisted_2 = { class: "footerFixed" };
const _hoisted_3 = {
    id: "all_wrapper",
    class: "mentor_request career"
};
const _hoisted_4 = { class: "wrapper_1" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("h2", null, "メンター申請（経歴入力）", -1);
const _hoisted_6 = { class: "inner" };
const _hoisted_7 = /*#__PURE__*/ _createStaticVNode("<ul class=\"step_4\"><li class=\"off2\">基本入力</li><li class=\"active\">経歴入力<i class=\"fas fa-caret-up step-triangle\"></i></li><li class=\"off\">審査問い</li><li class=\"off\">完了</li></ul>", 1);
const _hoisted_8 = ["onSubmit"];
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("dt", { class: "must" }, [
    /*#__PURE__*/ _createTextVNode(" 自己紹介"),
    /*#__PURE__*/ _createElementVNode("br", { class: "pc" }),
    /*#__PURE__*/ _createElementVNode("span", { class: "must" }, "必須"),
    /*#__PURE__*/ _createElementVNode("span", { class: "public" }, "公開")
], -1);
const _hoisted_10 = {
    key: 0,
    class: "err"
};
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("dt", { class: "must" }, [
    /*#__PURE__*/ _createTextVNode(" スキル要約"),
    /*#__PURE__*/ _createElementVNode("br", { class: "pc" }),
    /*#__PURE__*/ _createElementVNode("span", { class: "must" }, "必須"),
    /*#__PURE__*/ _createElementVNode("span", { class: "public" }, "公開")
], -1);
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("span", null, "例：コールセンター構築・保守の経験と知見", -1);
const _hoisted_13 = {
    key: 0,
    class: "err"
};
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("dt", { class: "must" }, [
    /*#__PURE__*/ _createTextVNode("職歴"),
    /*#__PURE__*/ _createElementVNode("br", { class: "pc" }),
    /*#__PURE__*/ _createElementVNode("span", { class: "must" }, "必須")
], -1);
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("label", { for: "q1_a1" }, "公開", -1);
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("label", { for: "q1_a2" }, "非公開", -1);
const _hoisted_17 = { class: "job_box" };
const _hoisted_18 = { class: "bt_right" };
const _hoisted_19 = ["onClick"];
const _hoisted_20 = ["onClick"];
const _hoisted_21 = { class: "l1" };
const _hoisted_22 = /*#__PURE__*/ _createElementVNode("p", { class: "sub_t" }, "期間", -1);
const _hoisted_23 = { class: "l1" };
const _hoisted_24 = /*#__PURE__*/ _createElementVNode("p", { class: "sub_t" }, "組織", -1);
const _hoisted_25 = { class: "l2" };
const _hoisted_26 = /*#__PURE__*/ _createElementVNode("p", { class: "sub_t" }, "部署", -1);
const _hoisted_27 = { class: "l2" };
const _hoisted_28 = /*#__PURE__*/ _createElementVNode("p", { class: "sub_t" }, "役職", -1);
const _hoisted_29 = {
    class: "l1",
    style: { "white-space": "pre-line" }
};
const _hoisted_30 = /*#__PURE__*/ _createElementVNode("p", { class: "sub_t" }, "経験内容", -1);
const _hoisted_31 = {
    key: 0,
    class: "err"
};
const _hoisted_32 = /*#__PURE__*/ _createElementVNode("dt", { class: "must" }, [
    /*#__PURE__*/ _createTextVNode(" 最終学歴"),
    /*#__PURE__*/ _createElementVNode("br", { class: "pc" }),
    /*#__PURE__*/ _createElementVNode("span", { class: "optionally" }, "任意"),
    /*#__PURE__*/ _createElementVNode("span", { class: "public" }, "公開")
], -1);
const _hoisted_33 = /*#__PURE__*/ _createElementVNode("dt", { class: "must" }, [
    /*#__PURE__*/ _createTextVNode(" 資格"),
    /*#__PURE__*/ _createElementVNode("br", { class: "pc" }),
    /*#__PURE__*/ _createElementVNode("span", { class: "optionally" }, "任意"),
    /*#__PURE__*/ _createElementVNode("span", { class: "public" }, "公開")
], -1);
const _hoisted_34 = /*#__PURE__*/ _createElementVNode("dt", { class: "must" }, [
    /*#__PURE__*/ _createTextVNode(" 語学"),
    /*#__PURE__*/ _createElementVNode("br", { class: "pc" }),
    /*#__PURE__*/ _createElementVNode("span", { class: "optionally" }, "任意"),
    /*#__PURE__*/ _createElementVNode("span", { class: "public" }, "公開")
], -1);
const _hoisted_35 = /*#__PURE__*/ _createElementVNode("dt", { class: "must" }, [
    /*#__PURE__*/ _createTextVNode(" 応募動機"),
    /*#__PURE__*/ _createElementVNode("br", { class: "pc" }),
    /*#__PURE__*/ _createElementVNode("span", { class: "must" }, "必須"),
    /*#__PURE__*/ _createElementVNode("span", { class: "non_public" }, "非公開")
], -1);
const _hoisted_36 = {
    for: "01-A",
    class: "checkbox01 check_box"
};
const _hoisted_37 = /*#__PURE__*/ _createElementVNode("p", { class: "check_inner" }, "収入アップ", -1);
const _hoisted_38 = {
    for: "02-A",
    class: "checkbox01 check_box"
};
const _hoisted_39 = /*#__PURE__*/ _createElementVNode("span", { class: "check_inner" }, "スキルアップ", -1);
const _hoisted_40 = {
    for: "03-A",
    class: "checkbox01 check_box"
};
const _hoisted_41 = /*#__PURE__*/ _createElementVNode("span", { class: "check_inner" }, "社会貢献", -1);
const _hoisted_42 = {
    for: "04-A",
    class: "checkbox01 check_box"
};
const _hoisted_43 = /*#__PURE__*/ _createElementVNode("span", { class: "check_inner" }, "セルフブランディング", -1);
const _hoisted_44 = {
    for: "05-A",
    class: "checkbox01 check_box"
};
const _hoisted_45 = /*#__PURE__*/ _createElementVNode("span", { class: "check_inner" }, "顧客開拓", -1);
const _hoisted_46 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_47 = { class: "form-content-raw" };
const _hoisted_48 = {
    for: "06-A",
    class: "checkbox01 check_box"
};
const _hoisted_49 = /*#__PURE__*/ _createElementVNode("span", { class: "check_inner" }, "その他", -1);
const _hoisted_50 = {
    key: 0,
    class: "err"
};
const _hoisted_51 = {
    key: 1,
    class: "err"
};
const _hoisted_52 = { class: "bt_box" };
const _hoisted_53 = {
    key: 0,
    class: "err_list"
};
const _hoisted_54 = /*#__PURE__*/ _createElementVNode("li", null, [
    /*#__PURE__*/ _createElementVNode("button", {
        type: "submit",
        id: "submit-button",
        class: "bt_next",
        value: "次へ"
    }, " 次へ ")
], -1);
const _hoisted_55 = {
    id: "modal_del_1",
    class: "modal min js-modal"
};
const _hoisted_56 = /*#__PURE__*/ _createElementVNode("div", { class: "modal-bg bt_modal_close" }, null, -1);
const _hoisted_57 = { class: "modal-content" };
const _hoisted_58 = { class: "close_bt bt_modal_close" };
const _hoisted_59 = /*#__PURE__*/ _createElementVNode("h2", null, "削除してもよろしいですか？", -1);
const _hoisted_60 = /*#__PURE__*/ _createElementVNode("li", null, [
    /*#__PURE__*/ _createElementVNode("p", { class: "bt_modal_close bt_clear" }, "キャンセル")
], -1);
import { ref, reactive, watch, onMounted, onUnmounted, nextTick } from 'vue';
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
import Alert from '@util/BrowserAlert';
import PageExitConfirm from '@util/PageExitConfirm';
import InertiaUtil from '@util/InertiaUtil';
import Formatter from '@util/Formatter';
import CareerModal from '@component/Modals/CareerModal.vue';
import ImageFrame from '@component/ImageFrame.vue';
import { isObjEmpty } from '@util/Common';
export default /*#__PURE__*/ _defineComponent({
    __name: 'mentor_request_career',
    props: {
        common: null,
        errors: null
    },
    setup(__props) {
        const props = __props;
        const validate = reactive({ shot: false });
        const form = InertiaUtil.getForm({
            self_introduction: '',
            skill_summary: '',
            is_public_career: true,
            career: [],
            education: '',
            qualification: '',
            language: '',
            motivation: new Array,
            other_motivation: '',
        }, props.common.path);
        let careerIndex = null;
        let careerDelIndex = null;
        const career = ref({
            id: null,
            started_at: '',
            is_ended: true,
            ended_at: null,
            organization: '',
            department: '',
            position: '',
            experience_content: '',
        });
        // 文字数チェック
        watch(() => form.self_introduction, (value) => {
            if (Alert.charLimitTextArea(value)) {
                form.self_introduction = value.substring(0, Alert.TEXTAREA_LIMIT_NUMBER);
            }
        });
        watch(() => form.skill_summary, (value) => {
            if (Alert.charLimitTextArea(value)) {
                form.skill_summary = value.substring(0, Alert.TEXTAREA_LIMIT_NUMBER);
            }
        });
        watch(() => form.education, (value) => {
            if (Alert.charLimitText(value)) {
                form.education = value.substring(0, Alert.TEXT_LIMIT_NUMBER);
            }
        });
        watch(() => form.qualification, (value) => {
            if (Alert.charLimitTextArea(value)) {
                form.qualification = value.substring(0, Alert.TEXTAREA_LIMIT_NUMBER);
            }
        });
        watch(() => form.language, (value) => {
            if (Alert.charLimitTextArea(value)) {
                form.language = value.substring(0, Alert.TEXTAREA_LIMIT_NUMBER);
            }
        });
        watch(() => form.other_motivation, (value) => {
            if (Alert.charLimitText(value)) {
                form.other_motivation = value.substring(0, Alert.TEXT_LIMIT_NUMBER);
            }
        });
        // 編集チェック
        watch(() => form, () => PageExitConfirm.addEvent(), { deep: true });
        const onClickReturn = () => {
            window.history.back();
        };
        const onSubmit = () => {
            PageExitConfirm.removeEvent();
            InertiaUtil.post(form, route('mentor.register.verify_bio'), () => { validate.shot = true; });
        };
        // 職歴削除モーダルの表示イベント
        const onOpenCareerDelModal = (index) => {
            careerDelIndex = index;
        };
        // 職歴削除
        const onDeleteCareer = () => {
            if (null !== careerDelIndex) {
                form.career.splice(careerDelIndex, 1);
            }
        };
        // 職歴モーダルの表示イベント
        const onOpenCareerModal = (value, index) => {
            if (value && index !== undefined) {
                careerIndex = index;
                career.value = value;
                career.value.started_at = Formatter.formatDate(career.value.started_at, 'YYYY/MM');
                let endedAt = Formatter.formatDate(career.value.ended_at, 'YYYY/MM');
                career.value.ended_at = endedAt;
                career.value.is_ended = endedAt.trim() == '';
            }
            else {
                careerIndex = null;
                career.value = {
                    id: null,
                    started_at: '',
                    is_ended: true,
                    ended_at: null,
                    organization: '',
                    department: '',
                    position: '',
                    experience_content: '',
                };
            }
        };
        // 職歴モーダルの入力が完了した時のイベント
        const onInputCareerModal = (value) => {
            const data = reactive(Object.assign({}, value));
            if (null !== careerIndex) {
                form.career[careerIndex] = data;
            }
            else {
                form.career.push(data);
                nextTick(() => {
                    // 職歴を追加した際に編集・削除ボタンのモーダルイベントを設定し直す。
                    var key = require.resolve('@jquery/modal-jquery');
                    if (key)
                        delete require.cache[key];
                    require('@jquery/modal-jquery');
                });
            }
        };
        const workPeriod = (startedAt, endedAt) => {
            return Formatter.formatCareerPeriod(startedAt, endedAt);
        };
        onMounted(() => {
            validate.shot = isObjEmpty(props.errors);
            nextTick(() => {
                var key = require.resolve('@jquery/datepicker-jquery');
                if (key)
                    delete require.cache[key];
                require('@jquery/datepicker-jquery');
                // 既に読み込まれていたら一旦削除して、読み込み直す。
                var key = require.resolve('@jquery/modal-jquery');
                if (key)
                    delete require.cache[key];
                require('@jquery/modal-jquery');
            });
        });
        onUnmounted(() => {
            PageExitConfirm.removeEvent();
        });
        return (_ctx, _cache) => {
            var _a, _b, _c, _d, _e;
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(headerVue, {
                    common: props.common
                }, null, 8, ["common"]),
                _hoisted_1,
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _hoisted_5,
                            _createElementVNode("div", _hoisted_6, [
                                _hoisted_7,
                                _createElementVNode("form", {
                                    onSubmit: _withModifiers(onSubmit, ["prevent"])
                                }, [
                                    _createElementVNode("dl", null, [
                                        _hoisted_9,
                                        _createElementVNode("dd", null, [
                                            _withDirectives(_createElementVNode("textarea", {
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(form).self_introduction) = $event)),
                                                placeholder: "入力してください",
                                                id: "textarea_1",
                                                oninput: "resizeTextarea(1,7)"
                                            }, null, 512), [
                                                [_vModelText, _unref(form).self_introduction]
                                            ]),
                                            (validate.shot && ((_a = props.errors) === null || _a === void 0 ? void 0 : _a.self_introduction))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(props.errors.self_introduction), 1))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _hoisted_11,
                                        _createElementVNode("dd", null, [
                                            _withDirectives(_createElementVNode("textarea", {
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(form).skill_summary) = $event)),
                                                placeholder: "入力してください",
                                                id: "textarea_2",
                                                oninput: "resizeTextarea(2,7)"
                                            }, null, 512), [
                                                [_vModelText, _unref(form).skill_summary]
                                            ]),
                                            _hoisted_12,
                                            (validate.shot && ((_b = props.errors) === null || _b === void 0 ? void 0 : _b.skill_summary))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(props.errors.skill_summary), 1))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _hoisted_14,
                                        _createElementVNode("dd", null, [
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(form).is_public_career) = $event)),
                                                value: true,
                                                class: "visually-hidden",
                                                type: "radio",
                                                name: "q1",
                                                id: "q1_a1"
                                            }, null, 512), [
                                                [_vModelRadio, _unref(form).is_public_career]
                                            ]),
                                            _hoisted_15,
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(form).is_public_career) = $event)),
                                                value: false,
                                                class: "visually-hidden",
                                                type: "radio",
                                                name: "q1",
                                                id: "q1_a2"
                                            }, null, 512), [
                                                [_vModelRadio, _unref(form).is_public_career]
                                            ]),
                                            _hoisted_16,
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(form).career, (value, index) => {
                                                return (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                                    _createElementVNode("div", _hoisted_18, [
                                                        _createElementVNode("a", {
                                                            class: "bt_change modal_win",
                                                            "data-target": "modal_del_1",
                                                            onClick: _withModifiers(($event) => (onOpenCareerDelModal(index)), ["prevent"])
                                                        }, "削除", 8, _hoisted_19),
                                                        _createElementVNode("a", {
                                                            class: "bt_change modal_win",
                                                            "data-target": "career-modal",
                                                            onClick: _withModifiers(($event) => (onOpenCareerModal(value, index)), ["prevent"])
                                                        }, "変更", 8, _hoisted_20)
                                                    ]),
                                                    _createElementVNode("ul", null, [
                                                        _createElementVNode("li", _hoisted_21, [
                                                            _hoisted_22,
                                                            _createTextVNode(" " + _toDisplayString(workPeriod(value.started_at, value.ended_at)), 1)
                                                        ]),
                                                        _createElementVNode("li", _hoisted_23, [
                                                            _hoisted_24,
                                                            _createTextVNode(" " + _toDisplayString(value.organization), 1)
                                                        ]),
                                                        _createElementVNode("li", _hoisted_25, [
                                                            _hoisted_26,
                                                            _createTextVNode(" " + _toDisplayString(value.department), 1)
                                                        ]),
                                                        _createElementVNode("li", _hoisted_27, [
                                                            _hoisted_28,
                                                            _createTextVNode(" " + _toDisplayString(value.position), 1)
                                                        ]),
                                                        _createElementVNode("li", _hoisted_29, [
                                                            _hoisted_30,
                                                            _createTextVNode(" " + _toDisplayString(value.experience_content), 1)
                                                        ])
                                                    ])
                                                ]));
                                            }), 256)),
                                            (validate.shot && ((_c = props.errors) === null || _c === void 0 ? void 0 : _c.career))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_31, _toDisplayString(props.errors.career), 1))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("a", {
                                                class: "bt_change modal_win",
                                                "data-target": "career-modal",
                                                onClick: _cache[4] || (_cache[4] = _withModifiers(($event) => (onOpenCareerModal()), ["prevent"]))
                                            }, "追加")
                                        ]),
                                        _hoisted_32,
                                        _createElementVNode("dd", null, [
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_unref(form).education) = $event)),
                                                type: "text",
                                                name: "q2",
                                                class: "wmax inquiry-form",
                                                placeholder: "例：○○大学□□学部"
                                            }, null, 512), [
                                                [_vModelText, _unref(form).education]
                                            ])
                                        ]),
                                        _hoisted_33,
                                        _createElementVNode("dd", null, [
                                            _withDirectives(_createElementVNode("textarea", {
                                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_unref(form).qualification) = $event)),
                                                placeholder: "例：第二種情報処理技術者",
                                                id: "textarea_4",
                                                oninput: "resizeTextarea(4,7)"
                                            }, null, 512), [
                                                [_vModelText, _unref(form).qualification]
                                            ])
                                        ]),
                                        _hoisted_34,
                                        _createElementVNode("dd", null, [
                                            _withDirectives(_createElementVNode("textarea", {
                                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_unref(form).language) = $event)),
                                                placeholder: "例：TOEIC 700点",
                                                id: "textarea_5",
                                                oninput: "resizeTextarea(5,7)"
                                            }, null, 512), [
                                                [_vModelText, _unref(form).language]
                                            ])
                                        ]),
                                        _hoisted_35,
                                        _createElementVNode("dd", null, [
                                            _createElementVNode("label", _hoisted_36, [
                                                _withDirectives(_createElementVNode("input", {
                                                    value: "1",
                                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_unref(form).motivation) = $event)),
                                                    type: "checkbox",
                                                    id: "01-A",
                                                    name: "checkbox01"
                                                }, null, 512), [
                                                    [_vModelCheckbox, _unref(form).motivation]
                                                ]),
                                                _hoisted_37
                                            ]),
                                            _createElementVNode("label", _hoisted_38, [
                                                _withDirectives(_createElementVNode("input", {
                                                    value: "2",
                                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_unref(form).motivation) = $event)),
                                                    type: "checkbox",
                                                    id: "02-A",
                                                    name: "checkbox01"
                                                }, null, 512), [
                                                    [_vModelCheckbox, _unref(form).motivation]
                                                ]),
                                                _hoisted_39
                                            ]),
                                            _createElementVNode("label", _hoisted_40, [
                                                _withDirectives(_createElementVNode("input", {
                                                    value: "3",
                                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_unref(form).motivation) = $event)),
                                                    type: "checkbox",
                                                    id: "03-A",
                                                    name: "checkbox01"
                                                }, null, 512), [
                                                    [_vModelCheckbox, _unref(form).motivation]
                                                ]),
                                                _hoisted_41
                                            ]),
                                            _createElementVNode("label", _hoisted_42, [
                                                _withDirectives(_createElementVNode("input", {
                                                    value: "4",
                                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_unref(form).motivation) = $event)),
                                                    type: "checkbox",
                                                    id: "04-A",
                                                    name: "checkbox01"
                                                }, null, 512), [
                                                    [_vModelCheckbox, _unref(form).motivation]
                                                ]),
                                                _hoisted_43
                                            ]),
                                            _createElementVNode("label", _hoisted_44, [
                                                _withDirectives(_createElementVNode("input", {
                                                    value: "5",
                                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_unref(form).motivation) = $event)),
                                                    type: "checkbox",
                                                    id: "05-A",
                                                    name: "checkbox01"
                                                }, null, 512), [
                                                    [_vModelCheckbox, _unref(form).motivation]
                                                ]),
                                                _hoisted_45
                                            ]),
                                            _hoisted_46,
                                            _createElementVNode("div", _hoisted_47, [
                                                _createElementVNode("label", _hoisted_48, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        value: "9999",
                                                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_unref(form).motivation) = $event)),
                                                        type: "checkbox",
                                                        id: "06-A",
                                                        name: "checkbox01"
                                                    }, null, 512), [
                                                        [_vModelCheckbox, _unref(form).motivation]
                                                    ]),
                                                    _hoisted_49
                                                ]),
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((_unref(form).other_motivation) = $event)),
                                                    class: "wmax",
                                                    type: "text",
                                                    placeholder: "理由"
                                                }, null, 512), [
                                                    [_vModelText, _unref(form).other_motivation]
                                                ])
                                            ]),
                                            (validate.shot && ((_d = props.errors) === null || _d === void 0 ? void 0 : _d.motivation))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_50, _toDisplayString(props.errors.motivation), 1))
                                                : _createCommentVNode("", true),
                                            (validate.shot && ((_e = props.errors) === null || _e === void 0 ? void 0 : _e.other_motivation))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_51, _toDisplayString(props.errors.other_motivation), 1))
                                                : _createCommentVNode("", true)
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_52, [
                                        (validate.shot)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.errors, (error) => {
                                                    return (_openBlock(), _createElementBlock("p", null, _toDisplayString(error), 1));
                                                }), 256))
                                            ]))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("ul", null, [
                                            _createElementVNode("li", null, [
                                                _createElementVNode("button", {
                                                    type: "button",
                                                    id: "submit-button",
                                                    class: "bt_back",
                                                    onClick: onClickReturn,
                                                    value: "戻る"
                                                }, " 戻る ")
                                            ]),
                                            _hoisted_54
                                        ])
                                    ])
                                ], 40, _hoisted_8)
                            ])
                        ])
                    ]),
                    _createElementVNode("form", null, [
                        _createVNode(CareerModal, {
                            form: career.value,
                            onInput: onInputCareerModal
                        }, null, 8, ["form"]),
                        _createElementVNode("div", _hoisted_55, [
                            _hoisted_56,
                            _createElementVNode("div", _hoisted_57, [
                                _createElementVNode("div", _hoisted_58, [
                                    _createVNode(ImageFrame, { src: "images/common/i_bt_close.svg" })
                                ]),
                                _createElementVNode("div", { class: "pop" }, [
                                    _hoisted_59,
                                    _createElementVNode("div", { class: "bt_box clear" }, [
                                        _createElementVNode("ul", { class: "modalBtn-area b2" }, [
                                            _hoisted_60,
                                            _createElementVNode("li", null, [
                                                _createElementVNode("p", {
                                                    class: "bt_modal_close bt_ok",
                                                    onClick: onDeleteCareer
                                                }, "OK")
                                            ])
                                        ])
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    _createVNode(footerVue)
                ])
            ]));
        };
    }
});
